// Translations for Arabic and German - Complete Version

export const translations = {
  ar: {
    // General
    appName: 'نظام إدارة الشموسية',
    patriarchate: 'بطريركية الأقباط الأرثوذكس',
    diocese: 'إيبارشية جنوب ألمانيا',
    copyright: '© 2025 جميع الحقوق محفوظة',
    deaconManagement: 'نظام إدارة خدمات الشموسية',
    
    // Login Page
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    enterUsername: 'أدخل اسم المستخدم',
    enterPassword: 'أدخل كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    loggingIn: 'جاري تسجيل الدخول...',
    newChurch: 'كنيسة جديدة؟',
    registerNewChurch: 'تسجيل كنيسة جديدة',
    
    // Forgot/Reset Password
    forgotPasswordTitle: 'نسيت كلمة المرور',
    resetPassword: 'إعادة تعيين كلمة المرور',
    email: 'البريد الإلكتروني',
    enterEmail: 'أدخل بريدك الإلكتروني',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    sending: 'جاري الإرسال...',
    emailSent: 'تم الإرسال!',
    emailSentMessage: 'إذا كان البريد الإلكتروني مسجلاً، ستصلك رسالة تحتوي على رابط لإعادة تعيين كلمة المرور.',
    checkInbox: 'يرجى التحقق من صندوق الوارد والبريد المزعج.',
    backToLogin: 'العودة لتسجيل الدخول',
    forgotPasswordInstructions: 'أدخل بريدك الإلكتروني المسجل وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    enterNewPassword: 'أدخل كلمة المرور الجديدة',
    reenterPassword: 'أعد إدخال كلمة المرور',
    resetting: 'جاري إعادة التعيين...',
    resetSuccess: 'تم بنجاح!',
    resetSuccessMessage: 'تم إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
    invalidLink: 'رابط غير صالح',
    invalidLinkMessage: 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية',
    verifyingLink: 'جاري التحقق من الرابط...',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordTooShort: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    oldPassword: 'كلمة المرور القديمة',
    enterOldPassword: 'أدخل كلمة المرور القديمة',
    changePassword: 'تغيير كلمة المرور',
    
    // Church Registration
    churchRegistration: 'تسجيل كنيسة جديدة',
    churchName: 'اسم الكنيسة',
    churchNameShort: 'الاسم المختصر',
    churchLocation: 'الموقع',
    churchDiocese: 'الإيبارشية',
    adminUsername: 'اسم مستخدم المدير',
    adminPassword: 'كلمة مرور المدير',
    adminEmail: 'البريد الإلكتروني للمدير',
    adminFullName: 'الاسم الكامل للمدير',
    adminPhone: 'رقم هاتف المدير',
    register: 'تسجيل',
    registering: 'جاري التسجيل...',
    back: 'رجوع',
    
    // Dashboard
    dashboard: 'لوحة التحكم',
    today: 'اليوم',
    gregorianCalendar: 'التقويم الميلادي',
    copticCalendar: 'التقويم القبطي',
    
    // Navigation / Tabs
    assignments: 'تسجيل الخدمات والقراءات',
    bulkAttendance: 'تسجيل حضور جماعي',
    deaconManagementTab: 'إدارة الشمامسة',
    serviceTypes: 'أنواع الخدمات',
    statistics: 'الإحصائيات',
    serviceManagement: 'إدارة الخدمات',
    dataManagement: 'إدارة البيانات',
    settings: 'الإعدادات',
    users: 'المستخدمين',
    churchSettings: 'إعدادات الكنيسة',
    reloadData: 'إعادة تحميل البيانات',
    
    // Deacons
    deacons: 'الشمامسة',
    deacon: 'شماس',
    addDeacon: 'إضافة شماس',
    editDeacon: 'تعديل شماس',
    deleteDeacon: 'حذف شماس',
    deaconName: 'اسم الشماس',
    phone: 'الهاتف',
    address: 'العنوان',
    search: 'بحث',
    searchDeacons: 'بحث في الشمامسة...',
    noDeaconsFound: 'لا يوجد شمامسة',
    selectDeacons: 'اختيار الشمامسة',
    selectedDeacons: 'تم اختيار',
    selectAll: 'اختيار الكل',
    deselectAll: 'إلغاء الكل',
    
    // Assignments
    addAssignment: 'إضافة توزيع جديد',
    newAssignment: 'إضافة توزيع جديد',
    selectDeacon: 'اختر الشماس',
    selectReadingType: 'اختر نوع القراءة',
    selectServiceType: 'اختر نوع الخدمة أو القراءة',
    selectDate: 'اختيار التاريخ',
    date: 'التاريخ',
    selectedDate: 'التاريخ المحدد',
    readingType: 'نوع القراءة',
    serviceType: 'نوع الخدمة/القراءة',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    noAssignments: 'لا توجد توزيعات لهذا التاريخ',
    assignmentsForDate: 'تسجيل الخدمات والقراءات',
    registerAttendance: 'تسجيل حضور',
    
    // Bishop Dashboard
    bishopDashboard: 'لوحة تحكم نيافة الأسقف',
    superAdminDashboard: 'لوحة تحكم المدير العام',
    totalChurches: 'إجمالي الكنائس',
    totalDeacons: 'إجمالي الشمامسة',
    totalUsers: 'إجمالي المستخدمين',
    totalAssignments: 'إجمالي التوزيعات',
    registeredChurches: 'الكنائس المسجلة',
    manage: 'إدارة',
    viewDeacons: 'الشمامسة',
    viewAssignments: 'التوزيعات',
    exportReport: 'تقرير',
    details: 'التفاصيل',
    exportSummaryReport: 'تصدير تقرير شامل',
    
    // Impersonation
    browsingAsAdmin: 'أنت تتصفح كمدير كنيسة',
    returnToBishopDashboard: 'العودة للوحة الأسقف',
    
    // Service Types
    serviceTypeName: 'اسم الخدمة',
    addServiceType: 'إضافة نوع خدمة',
    editServiceType: 'تعديل نوع الخدمة',
    deleteServiceType: 'حذف نوع الخدمة',
    serviceDescription: 'وصف الخدمة',
    includeInStats: 'إدراج في الإحصائيات',
    
    // Settings
    accountSettings: 'إعدادات الحساب',
    saveSettings: 'حفظ الإعدادات',
    editProfile: 'تعديل المعلومات',
    personalInfo: 'المعلومات الشخصية',
    fullName: 'الاسم الكامل',
    notSpecified: 'غير محدد',
    cannotChange: 'لا يمكن تغييره',
    permissions: 'الصلاحية',
    
    // Users
    addUser: 'إضافة مستخدم',
    createUser: 'إنشاء مستخدم جديد',
    userManagement: 'إدارة المستخدمين (المدير فقط)',
    role: 'الدور',
    admin: 'مدير',
    user: 'مستخدم',
    normalUser: 'مستخدم عادي',
    enabled: 'مفعّل',
    disabled: 'معطّل',
    enable: 'تفعيل',
    disable: 'تعطيل',
    
    // Status Messages
    loading: 'جاري التحميل...',
    loadingData: 'جاري تحميل البيانات...',
    loadingFirstTime: 'قد يستغرق التحميل بضع ثواني عند فتح التطبيق لأول مرة',
    saving: 'جاري الحفظ...',
    creating: 'جاري الإنشاء...',
    savedSuccessfully: 'تم الحفظ بنجاح',
    deletedSuccessfully: 'تم الحذف بنجاح',
    addedSuccessfully: 'تم الإضافة بنجاح',
    updatedSuccessfully: 'تم التحديث بنجاح',
    errorOccurred: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    yes: 'نعم',
    no: 'لا',
    retry: 'إعادة محاولة',
    reload: 'إعادة تحميل',
    
    // Error Messages
    errorLoadingData: 'خطأ في تحميل البيانات',
    errorLoadingDeacons: 'خطأ في تحميل الشمامسة',
    errorLoadingAssignments: 'خطأ في تحميل التوزيعات',
    errorLoadingStatistics: 'خطأ في تحميل الإحصائيات',
    errorAddingDeacon: 'خطأ في إضافة الشماس',
    errorEditingDeacon: 'خطأ في تعديل الشماس',
    errorDeletingDeacon: 'خطأ في حذف الشماس',
    errorAddingAssignment: 'خطأ في إضافة التوزيع',
    errorEditingAssignment: 'خطأ في تعديل التوزيع',
    errorDeletingAssignment: 'خطأ في حذف التوزيع',
    errorExporting: 'خطأ في تصدير البيانات',
    errorImporting: 'خطأ في استيراد البيانات',
    errorChangingPassword: 'خطأ في تغيير كلمة المرور',
    wrongPassword: 'كلمة مرور خاطئة',
    notFound: 'غير موجود',
    pleaseReloadPage: 'يرجى إعادة تحميل الصفحة',
    weakConnection: 'اتصال ضعيف بالخادم - قد تحتاج لإعادة تحميل الصفحة',
    pleaseEnterDeaconName: 'يرجى إدخال اسم الشماس',
    pleaseSelectDeaconAndService: 'يرجى اختيار الشماس ونوع الخدمة',
    pleaseSelectServiceAndDeacon: 'يرجى اختيار نوع القراءة وشماس واحد على الأقل',
    
    // Success Messages
    deaconAddedSuccessfully: 'تم إضافة الشماس بنجاح',
    deaconEditedSuccessfully: 'تم تعديل الشماس بنجاح',
    deaconDeletedSuccessfully: 'تم حذف الشماس بنجاح',
    assignmentAddedSuccessfully: 'تم إضافة التوزيع بنجاح',
    assignmentEditedSuccessfully: 'تم تعديل التوزيع بنجاح',
    assignmentDeletedSuccessfully: 'تم حذف التوزيع بنجاح',
    dataExportedSuccessfully: 'تم تصدير البيانات بنجاح',
    dataImportedSuccessfully: 'تم استيراد البيانات بنجاح',
    passwordChangedSuccessfully: 'تم تغيير كلمة المرور بنجاح',
    serviceTypeAddedSuccessfully: 'تم إضافة نوع الخدمة بنجاح',
    serviceTypeEditedSuccessfully: 'تم تعديل نوع الخدمة بنجاح',
    serviceTypeDeletedSuccessfully: 'تم حذف نوع الخدمة بنجاح',
    userCreatedSuccessfully: 'تم إنشاء المستخدم بنجاح',
    userDeletedSuccessfully: 'تم حذف المستخدم بنجاح',
    userStatusUpdated: 'تم تحديث حالة المستخدم',
    churchSettingsUpdated: 'تم تحديث معلومات الكنيسة بنجاح',
    allDataCleared: 'تم حذف جميع البيانات بنجاح',
    deaconsRegistered: 'تم تسجيل {count} شماس بنجاح',
    
    // Print
    print: 'طباعة',
    printSchedule: 'طباعة الجدول',
    weeklySchedule: 'جدول الأسبوع',
    
    // Excel
    downloadTemplate: 'تحميل القالب',
    importFromExcel: 'استيراد من Excel',
    exportToExcel: 'تصدير Excel',
    importDeacons: 'استيراد الشمامسة',
    importAssignments: 'استيراد التوزيعات',
    
    // Days
    sunday: 'الأحد',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    
    // Language
    language: 'اللغة',
    arabic: 'العربية',
    german: 'Deutsch',
    
    // Database
    database: 'قاعدة البيانات',
    clearAllData: 'حذف جميع البيانات',
    
    // Misc
    active: 'نشط',
    inactive: 'غير نشط',
    status: 'الحالة',
    actions: 'الإجراءات',
    fullPermissions: 'صلاحيات كاملة',
    adminOnly: 'المدير فقط',
    required: 'مطلوب',
    optional: 'اختياري',
    total: 'الإجمالي',
    count: 'العدد',
    name: 'الاسم',
    description: 'الوصف',
    noData: 'لا توجد بيانات',
    close: 'إغلاق',
    confirm: 'تأكيد',
    saveChanges: 'حفظ التغييرات',
    
    // Statistics
    totalReadings: 'إجمالي القراءات',
    inactiveDeacons: 'الشمامسة غير المشاركين',
    readingsByType: 'تصنيف القراءات',
    readingDetails: 'تفاصيل القراءات',
    noParticipation: 'لا يوجد شمامسة غير مشاركين',
    
    // Calendar
    selectCalendarDate: 'اختيار التاريخ',
  },
  
  de: {
    // General
    appName: 'Diakonenverwaltung',
    patriarchate: 'Koptisch-Orthodoxes Patriarchat',
    diocese: 'Diözese Süddeutschland',
    copyright: '© 2025 Alle Rechte vorbehalten',
    deaconManagement: 'Diakonendienst-Verwaltungssystem',
    
    // Login Page
    login: 'Anmelden',
    logout: 'Abmelden',
    username: 'Benutzername',
    password: 'Passwort',
    enterUsername: 'Benutzername eingeben',
    enterPassword: 'Passwort eingeben',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    loggingIn: 'Anmeldung läuft...',
    newChurch: 'Neue Kirche?',
    registerNewChurch: 'Neue Kirche registrieren',
    
    // Forgot/Reset Password
    forgotPasswordTitle: 'Passwort vergessen',
    resetPassword: 'Passwort zurücksetzen',
    email: 'E-Mail',
    enterEmail: 'E-Mail-Adresse eingeben',
    sendResetLink: 'Link zum Zurücksetzen senden',
    sending: 'Wird gesendet...',
    emailSent: 'Gesendet!',
    emailSentMessage: 'Wenn die E-Mail registriert ist, erhalten Sie einen Link zum Zurücksetzen des Passworts.',
    checkInbox: 'Bitte überprüfen Sie Ihren Posteingang und Spam-Ordner.',
    backToLogin: 'Zurück zur Anmeldung',
    forgotPasswordInstructions: 'Geben Sie Ihre registrierte E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    enterNewPassword: 'Neues Passwort eingeben',
    reenterPassword: 'Passwort erneut eingeben',
    resetting: 'Wird zurückgesetzt...',
    resetSuccess: 'Erfolgreich!',
    resetSuccessMessage: 'Das Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit dem neuen Passwort anmelden.',
    invalidLink: 'Ungültiger Link',
    invalidLinkMessage: 'Der Link ist ungültig oder abgelaufen',
    verifyingLink: 'Link wird überprüft...',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen haben',
    oldPassword: 'Altes Passwort',
    enterOldPassword: 'Altes Passwort eingeben',
    changePassword: 'Passwort ändern',
    
    // Church Registration
    churchRegistration: 'Neue Kirche registrieren',
    churchName: 'Kirchenname',
    churchNameShort: 'Kurzname',
    churchLocation: 'Standort',
    churchDiocese: 'Diözese',
    adminUsername: 'Admin-Benutzername',
    adminPassword: 'Admin-Passwort',
    adminEmail: 'Admin-E-Mail',
    adminFullName: 'Vollständiger Name des Admins',
    adminPhone: 'Admin-Telefonnummer',
    register: 'Registrieren',
    registering: 'Wird registriert...',
    back: 'Zurück',
    
    // Dashboard
    dashboard: 'Dashboard',
    today: 'Heute',
    gregorianCalendar: 'Gregorianischer Kalender',
    copticCalendar: 'Koptischer Kalender',
    
    // Navigation / Tabs
    assignments: 'Dienste & Lesungen',
    bulkAttendance: 'Gruppenanwesenheit',
    deaconManagementTab: 'Diakonenverwaltung',
    serviceTypes: 'Dienstarten',
    statistics: 'Statistiken',
    serviceManagement: 'Dienstverwaltung',
    dataManagement: 'Datenverwaltung',
    settings: 'Einstellungen',
    users: 'Benutzer',
    churchSettings: 'Kircheneinstellungen',
    reloadData: 'Daten neu laden',
    
    // Deacons
    deacons: 'Diakone',
    deacon: 'Diakon',
    addDeacon: 'Diakon hinzufügen',
    editDeacon: 'Diakon bearbeiten',
    deleteDeacon: 'Diakon löschen',
    deaconName: 'Name des Diakons',
    phone: 'Telefon',
    address: 'Adresse',
    search: 'Suchen',
    searchDeacons: 'Diakon suchen...',
    noDeaconsFound: 'Keine Diakone gefunden',
    selectDeacons: 'Diakone auswählen',
    selectedDeacons: 'Ausgewählt',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    
    // Assignments
    addAssignment: 'Neue Zuweisung',
    newAssignment: 'Neue Zuweisung hinzufügen',
    selectDeacon: 'Diakon auswählen',
    selectReadingType: 'Lesungsart auswählen',
    selectServiceType: 'Dienst- oder Lesungsart auswählen',
    selectDate: 'Datum auswählen',
    date: 'Datum',
    selectedDate: 'Ausgewähltes Datum',
    readingType: 'Lesungsart',
    serviceType: 'Dienst-/Lesungsart',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    noAssignments: 'Keine Zuweisungen für dieses Datum',
    assignmentsForDate: 'Dienste & Lesungen erfassen',
    registerAttendance: 'Anwesenheit erfassen',
    
    // Bishop Dashboard
    bishopDashboard: 'Bischofs-Dashboard',
    superAdminDashboard: 'Super-Admin-Dashboard',
    totalChurches: 'Gesamtzahl der Kirchen',
    totalDeacons: 'Gesamtzahl der Diakone',
    totalUsers: 'Gesamtzahl der Benutzer',
    totalAssignments: 'Gesamtzahl der Zuweisungen',
    registeredChurches: 'Registrierte Kirchen',
    manage: 'Verwalten',
    viewDeacons: 'Diakone',
    viewAssignments: 'Zuweisungen',
    exportReport: 'Bericht',
    details: 'Details',
    exportSummaryReport: 'Gesamtbericht exportieren',
    
    // Impersonation
    browsingAsAdmin: 'Sie durchsuchen als Kirchenadmin',
    returnToBishopDashboard: 'Zurück zum Bischofs-Dashboard',
    
    // Service Types
    serviceTypeName: 'Dienstname',
    addServiceType: 'Dienstart hinzufügen',
    editServiceType: 'Dienstart bearbeiten',
    deleteServiceType: 'Dienstart löschen',
    serviceDescription: 'Beschreibung',
    includeInStats: 'In Statistiken einbeziehen',
    
    // Settings
    accountSettings: 'Kontoeinstellungen',
    saveSettings: 'Einstellungen speichern',
    editProfile: 'Profil bearbeiten',
    personalInfo: 'Persönliche Informationen',
    fullName: 'Vollständiger Name',
    notSpecified: 'Nicht angegeben',
    cannotChange: 'Kann nicht geändert werden',
    permissions: 'Berechtigungen',
    
    // Users
    addUser: 'Benutzer hinzufügen',
    createUser: 'Neuen Benutzer erstellen',
    userManagement: 'Benutzerverwaltung (nur Admin)',
    role: 'Rolle',
    admin: 'Administrator',
    user: 'Benutzer',
    normalUser: 'Normaler Benutzer',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    enable: 'Aktivieren',
    disable: 'Deaktivieren',
    
    // Status Messages
    loading: 'Wird geladen...',
    loadingData: 'Daten werden geladen...',
    loadingFirstTime: 'Das Laden kann beim ersten Öffnen einige Sekunden dauern',
    saving: 'Wird gespeichert...',
    creating: 'Wird erstellt...',
    savedSuccessfully: 'Erfolgreich gespeichert',
    deletedSuccessfully: 'Erfolgreich gelöscht',
    addedSuccessfully: 'Erfolgreich hinzugefügt',
    updatedSuccessfully: 'Erfolgreich aktualisiert',
    errorOccurred: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten?',
    yes: 'Ja',
    no: 'Nein',
    retry: 'Erneut versuchen',
    reload: 'Neu laden',
    
    // Error Messages
    errorLoadingData: 'Fehler beim Laden der Daten',
    errorLoadingDeacons: 'Fehler beim Laden der Diakone',
    errorLoadingAssignments: 'Fehler beim Laden der Zuweisungen',
    errorLoadingStatistics: 'Fehler beim Laden der Statistiken',
    errorAddingDeacon: 'Fehler beim Hinzufügen des Diakons',
    errorEditingDeacon: 'Fehler beim Bearbeiten des Diakons',
    errorDeletingDeacon: 'Fehler beim Löschen des Diakons',
    errorAddingAssignment: 'Fehler beim Hinzufügen der Zuweisung',
    errorEditingAssignment: 'Fehler beim Bearbeiten der Zuweisung',
    errorDeletingAssignment: 'Fehler beim Löschen der Zuweisung',
    errorExporting: 'Fehler beim Exportieren der Daten',
    errorImporting: 'Fehler beim Importieren der Daten',
    errorChangingPassword: 'Fehler beim Ändern des Passworts',
    wrongPassword: 'Falsches Passwort',
    notFound: 'Nicht gefunden',
    pleaseReloadPage: 'Bitte laden Sie die Seite neu',
    weakConnection: 'Schwache Serververbindung - Seite neu laden empfohlen',
    pleaseEnterDeaconName: 'Bitte geben Sie den Namen des Diakons ein',
    pleaseSelectDeaconAndService: 'Bitte wählen Sie einen Diakon und eine Dienstart',
    pleaseSelectServiceAndDeacon: 'Bitte wählen Sie eine Lesungsart und mindestens einen Diakon',
    
    // Success Messages
    deaconAddedSuccessfully: 'Diakon erfolgreich hinzugefügt',
    deaconEditedSuccessfully: 'Diakon erfolgreich bearbeitet',
    deaconDeletedSuccessfully: 'Diakon erfolgreich gelöscht',
    assignmentAddedSuccessfully: 'Zuweisung erfolgreich hinzugefügt',
    assignmentEditedSuccessfully: 'Zuweisung erfolgreich bearbeitet',
    assignmentDeletedSuccessfully: 'Zuweisung erfolgreich gelöscht',
    dataExportedSuccessfully: 'Daten erfolgreich exportiert',
    dataImportedSuccessfully: 'Daten erfolgreich importiert',
    passwordChangedSuccessfully: 'Passwort erfolgreich geändert',
    serviceTypeAddedSuccessfully: 'Dienstart erfolgreich hinzugefügt',
    serviceTypeEditedSuccessfully: 'Dienstart erfolgreich bearbeitet',
    serviceTypeDeletedSuccessfully: 'Dienstart erfolgreich gelöscht',
    userCreatedSuccessfully: 'Benutzer erfolgreich erstellt',
    userDeletedSuccessfully: 'Benutzer erfolgreich gelöscht',
    userStatusUpdated: 'Benutzerstatus aktualisiert',
    churchSettingsUpdated: 'Kircheneinstellungen erfolgreich aktualisiert',
    allDataCleared: 'Alle Daten erfolgreich gelöscht',
    deaconsRegistered: '{count} Diakon(e) erfolgreich registriert',
    
    // Print
    print: 'Drucken',
    printSchedule: 'Zeitplan drucken',
    weeklySchedule: 'Wochenplan',
    
    // Excel
    downloadTemplate: 'Vorlage herunterladen',
    importFromExcel: 'Aus Excel importieren',
    exportToExcel: 'Nach Excel exportieren',
    importDeacons: 'Diakone importieren',
    importAssignments: 'Zuweisungen importieren',
    
    // Days
    sunday: 'Sonntag',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    
    // Language
    language: 'Sprache',
    arabic: 'العربية',
    german: 'Deutsch',
    
    // Database
    database: 'Datenbank',
    clearAllData: 'Alle Daten löschen',
    
    // Misc
    active: 'Aktiv',
    inactive: 'Inaktiv',
    status: 'Status',
    actions: 'Aktionen',
    fullPermissions: 'Volle Berechtigungen',
    adminOnly: 'Nur Admin',
    required: 'Erforderlich',
    optional: 'Optional',
    total: 'Gesamt',
    count: 'Anzahl',
    name: 'Name',
    description: 'Beschreibung',
    noData: 'Keine Daten',
    close: 'Schließen',
    confirm: 'Bestätigen',
    saveChanges: 'Änderungen speichern',
    
    // Statistics
    totalReadings: 'Gesamtzahl der Lesungen',
    inactiveDeacons: 'Inaktive Diakone',
    readingsByType: 'Lesungen nach Typ',
    readingDetails: 'Lesungsdetails',
    noParticipation: 'Keine inaktiven Diakone',
    
    // Calendar
    selectCalendarDate: 'Datum auswählen',
  }
};

export default translations;
